import { Component, OnInit, ViewChild } from '@angular/core';
import { ViewRequest } from '../shared/view-request.model';
import { StateRequestsComponent } from '../state-requests/state-requests.component';
import { ReportsService } from '../shared/reports.service';
import { FilterRequestEvaluated } from '../shared/filter-request-evaluated.model';
import { UserService } from '../../requets/shared/user.service';
import { Role } from '../../requets/shared/model/Role.model';
import { BossDependence } from '../../requets/shared/model/boss-dependence.model';
import { RoleInformation } from 'src/app/core/shared/role-information.model';
import { UtilityService } from 'src/app/core/shared/utility.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-content-state-requests',
  templateUrl: './content-state-requests.component.html',
  styleUrls: ['./content-state-requests.component.scss']
})
export class ContentStateRequestsComponent implements OnInit {

  rolUnidadAcademica: String = 'maresASISTRECONUNIDACAD';
  rolAistenciaIdiomas: String = 'maresASISTRECONIDIOMAS';
  requests: ViewRequest[];
  enabledSpinner = false;
  roles: Role[] = [];
  bossDeependence: BossDependence;
  rolesApplication: Role[] = [];
  currentRol: Role;
  tipoRol: number;
  filterRequest: FilterRequestEvaluated;
  prueba: Boolean;
  @ViewChild(StateRequestsComponent) stateRequestsComponent: StateRequestsComponent;

  constructor(private reportService: ReportsService,
              private userService: UserService,
              private utilityService: UtilityService,
              private router: Router) { }

  ngOnInit() {
    this.prueba = false;
    this.getUserInformation();
  }

  refreshSearch() {
    this.sendFilter(this.filterRequest);
  }

  changeSpinner(estado: boolean) {
    this.enabledSpinner = estado;
  }

  getListRequestsState(filterRequest: FilterRequestEvaluated) {
    if (filterRequest.tipo === 'PRUEBA LENGUA EXTRANJERA') {
      this.reportService.getStateTesting(filterRequest.cedula, filterRequest.tipo).subscribe(
        (result) => {
          if (result.data) {
              this.requests = result.data as ViewRequest[];
              this.enabledSpinner = false;
          }
        }
      );
    } else {
      this.reportService.getStateRequests(filterRequest.cedula, filterRequest.tipo).subscribe(
        (result) => {
          if (result.data) {
              this.requests = result.data as ViewRequest[];
              this.enabledSpinner = false;
          }
        }
      );
    }

  }

  sendFilter(event: FilterRequestEvaluated) {
    this.filterRequest = event;
    if ( this.filterRequest.tipo === 'PRUEBA LENGUA EXTRANJERA') {
      this.prueba = true;
    } else {
      this.prueba = false;
    }
    this.enabledSpinner = true;
    this.getListRequestsState(this.filterRequest);
    this.stateRequestsComponent.messageError = '';
  }

  private getUserInformation() {
    const userid =  null;
    const cedula =  localStorage.getItem('cedula');
    this.userService.getUserInformation(userid, cedula).subscribe(
      (result) => {
        if (result.data) {
            this.roles =  result.data.roles as Role[];
            this.bossDeependence = result.data.jefeDepartamento as BossDependence;
             const roleInformation: RoleInformation = this.utilityService.validateRole(this.roles, 1);
             this.rolesApplication = roleInformation.roles;
             this.currentRol = roleInformation.currentRol;
             this.tipoRol = roleInformation.tipoValidation;
             if (this.tipoRol  === 0) {
              const parameters = {
                tipo: 'info',
                mensaje: 'Usted no posee el rol adecuado para acceder a esta opción'
              };
              this.router.navigate(['message'], {queryParams : parameters});
             }
             this.requests = [];
             this.enabledSpinner = false;

        }
      }
    );
  }

}
